/**
 * IFRAME 容器页
 */
import { connect } from 'react-redux';
import RichHeader from './RichHeader.jsx';
import { DOMAIN } from '../../constants/config';
import Footer from '../../components/footers/Original_Main.jsx';
 
class FrameContainer extends React.Component {

  constructor(props) {
    super(props);
    this.frameStyle = {
      width: '100%',
      minHeight: '500px',
      border: 0,
    }
    // 嵌套式地址与页面对应关系【后期废弃】
    switch(this.props.params.add){
      case 'withdraw': this.frameURL = 'emaildeposit/main?controller=security&action=platwithdraw'; break;
      default: window.location.href = '#/'
    }
  }

  componentDidMount(){
    this.iframe = document.getElementById('FrameContainer');
    this.iframe.onload = () => this.iframe.height = this.iframe.contentWindow.document.body.offsetHeight;
  }

  componentWillUnmount(){
    this.iframe.onload = null
  }

  render() {

    const __base =  this.props.__BASE.toJS();

    return (
      <div >
        <div>
          <RichHeader />
          <SideBar />
          <div className='pannel-content iframe-container'>
       		 <iframe id='FrameContainer' ref='frame' src={DOMAIN + this.frameURL} style={this.frameStyle} />
          </div>
          <div className="mt30"></div>
          <Footer />
        </div>
      </div>
    ); 

  }
}

reactMixin(FrameContainer.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
  }
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FrameContainer)